(() => {
  'use strict';
  const gallery = document.getElementById('ProductGallery');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (gallery) {
    const items = [...gallery.querySelectorAll('.gallery-item')];
    const previous = document.querySelector('[data-gallery-prev]'), next = document.querySelector('[data-gallery-next]');
    const count = document.querySelector('[data-gallery-count]');
    const mobile = matchMedia('(max-width:749px)');
    let active = 0, frame;
    const update = () => {
      frame = 0;
      if (!mobile.matches) return;
      let distance = Infinity;
      items.forEach((item,i) => { const d = Math.abs(item.getBoundingClientRect().left-gallery.getBoundingClientRect().left); if (d < distance) { distance = d; active = i; } });
      if (previous) previous.disabled = active === 0;
      if (next) next.disabled = active === items.length-1;
      if (count) count.textContent = `${String(active+1).padStart(2,'0')} / ${String(items.length).padStart(2,'0')}`;
      items.forEach((item,i) => { if (i !== active) item.querySelector('video')?.pause(); });
    };
    const go = delta => { const target = items[active+delta]; if (target) gallery.scrollTo({left:target.getBoundingClientRect().left-gallery.getBoundingClientRect().left+gallery.scrollLeft,behavior:motion.matches?'instant':'smooth'}); };
    previous?.addEventListener('click',()=>go(-1)); next?.addEventListener('click',()=>go(1));
    gallery.addEventListener('scroll',()=>{ if(!frame) frame=requestAnimationFrame(update); },{passive:true});
    mobile.addEventListener('change', update);
    new ResizeObserver(update).observe(gallery);
    update();
  }
  const film = document.getElementById('ProductFilmDialog'), video = film?.querySelector('video');
  if (film && video) {
    new MutationObserver(() => {
      if (film.open && !video.hasAttribute('src')) { video.src = video.dataset.productFilmSrc; video.load(); }
      if (!film.open) video.pause();
    }).observe(film,{attributes:true,attributeFilter:['open']});
    document.addEventListener('visibilitychange',()=>{ if(document.hidden) video.pause(); });
  }
  const sizeDialog = document.getElementById('ProductSizeDialog');
  if (sizeDialog) {
    const syncSize = () => {
      const selected = document.querySelector('.product-page input[name="variant-choice"]:checked');
      const label = selected?.nextElementSibling?.textContent?.trim().toUpperCase().replace('XXL','2XL');
      sizeDialog.querySelectorAll('tbody tr').forEach(row=>row.classList.toggle('is-selected',Boolean(label&&row.firstElementChild.textContent.trim().toUpperCase()===label)));
    };
    document.querySelector('.product-page [data-product-form]')?.addEventListener('change',syncSize);
    syncSize();
  }
})();
